import { ProposalDetailSkeleton } from '@/components/launchpad/proposal-detail-skeleton';

/**
 * Route-level Suspense fallback for the proposal-detail page. Renders the
 * shared {@link ProposalDetailSkeleton}, which mirrors the loaded layout
 * region-for-region via the same `PROPOSAL_DETAIL_*` layout classes the
 * page uses (header + hero panel, summary data-cell row, creator card +
 * data cells, backers region, desktop sticky rail) so the
 * skeleton→content swap is shift-free and reads as the right page.
 */
export default function ProposalDetailLoading(): React.ReactNode {
  return <ProposalDetailSkeleton />;
}
